import React from 'react';
export function DisclaimerSection() {
  return <div className="bg-gray-100 border-t border-gray-200 py-8 px-4" data-id="element-15">
      <div className="container mx-auto max-w-5xl text-center" data-id="element-16">
        <p className="text-xs text-gray-500 leading-relaxed" data-id="element-17">
          <strong data-id="element-18">Aviso Legal y Descargo de Responsabilidad:</strong> Este
          manual tiene fines educativos e informativos únicamente. La
          información aquí contenida no reemplaza el consejo, diagnóstico ni
          tratamiento médico profesional. Los remedios y fórmulas descritos son
          complementos de bienestar y no están destinados a diagnosticar,
          tratar, curar ni prevenir ninguna enfermedad. Si usted toma medicación
          crónica o tiene una condición médica compleja, consulte a su médico
          antes de incorporar cualquier cambio en su rutina de bienestar.
          <strong data-id="element-19">
            {' '}
            Nunca abandone un tratamiento médico prescripto basándose en
            información de este manual.
          </strong>
          Los resultados individuales pueden variar. Las declaraciones
          realizadas en este sitio no han sido evaluadas por ninguna autoridad
          regulatoria de salud.
        </p>
      </div>
    </div>;
}